/**
 * Кто управляет правами — ЕДИНСТВЕННЫЙ предикат веба для экрана прав
 * (Блок 2 · Ф8 · В-Э): блок «Права» в карточке человека, пункт меню и маршрут
 * сводного списка читают одно и то же значение.
 *
 * ─── Тот же предикат, что у стража маршрутов ────────────────────────────────
 *
 * Сервер закрывает маршруты прав порогом «уровень супервайзера И
 * `isAssignable === false`» (`rbac.guard.ts`; умолчание 4 Р-211): уровень
 * супервайзера несут ДВЕ должности — штатная и спящая `CEO`, и вторая не
 * проходит. Здесь — те же два признака, и оба приходят профилем: `GET /auth/me`
 * отдаёт актора целиком, ответ входа несёт `isAssignable` с фикс-пака 1.
 *
 * ⚠️ В первой редакции сверялось ИМЯ должности (`SYSADMIN`): совпадение с
 * сервером держалось на посеве, и смена данных дала бы либо спрятанный
 * разрешённый экран, либо видимый экран с 403 (находка ревью).
 *
 * «Не знаю» закрыто: профиль без поля (образ API до волны) экрана не открывает
 * — `undefined` не равен `false`.
 *
 * ⚠️ Это видимость, а не рубеж. Рубеж — сервер.
 */
import { AccessLevel } from '@aris/shared';

/** Та часть профиля, по которой решается видимость экрана прав. */
export interface RightsManagerSource {
  readonly accessLevel?: string | number | null;
  readonly isAssignable?: boolean | null;
}

export function canManageRights(actor: RightsManagerSource | null | undefined): boolean {
  if (actor == null) return false;
  return actor.accessLevel === AccessLevel.SUPERVISOR && actor.isAssignable === false;
}
